// Copyright 2018 Sorama B.V.

export enum ExportStage {
    Generating,
    Encoding,
}

/**
 * Represents an exportable object
 */
export interface Export {
    /**
     * Finishes the export
     * @param fileName Filename for the export
     */
    export(fileName: string, progressCallback?: (stage: ExportStage, progres: number) => void): Promise<void>;

    exportToBuffer(progressCallback?: (stage: ExportStage, progres: number) => void): Promise<ArrayBuffer>;
}

/**
 * Represents a visual exportable object
 */
export interface VisualExport extends Export {
    /**
     * Scales the export (respecting the aspect ratio) to the provided resolution
     * @param width Maximum width for the video
     * @param height Maximum height for the video
     */
    fitResolution(width: number, height: number): VisualExport;

    /**
     * Set the playback rate of the video. Default is 1.
     */
    setPlaybackRate(playbackRate: number): VisualExport;
}
